import { GetTemplatesRanges } from 'domain/usecases/reports/get-templates-ranges';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetTemplatesRanges extends BaseHttpService<GetTemplatesRanges.Model> implements GetTemplatesRanges {
  async get(params: GetTemplatesRanges.Params): Promise<GetTemplatesRanges.Model> {
    return await this.request('get', {}, params);
  }
}
